/**
 * Permet d'afficher un input
 * @param {object} item - objet contenant les données du formulaire
 * @param {function} register - fonction register de React Hook Form
 */

export default function Input({ item, register }) {
  return (
    <input
      type={item.type}
      id={item.id}
      {...register(item.id)}
      placeholder={item.placeholder ? item.placeholder : ""}
      defaultValue={item["value"] && item.value}
    />
  );
}
